import {
  AccountInfo,
  AuthenticationResult,
  IPublicClientApplication,
  PopupRequest,
  SilentRequest,
} from "@azure/msal-browser";
import { DATA_URL, IMAGE_URL, INMA_URL, STAC_URL } from "utils/constants";
import { getTokenRequest, graphTokenRequest } from "utils/helpers/auth";

export const authDomains = new Set([
  new URL(DATA_URL).host,
  new URL(IMAGE_URL).host,
  new URL(STAC_URL).host,
  new URL(INMA_URL).host,
  window.location.host,
]);

const graphDomains = new Set(["graph.microsoft.com"]);

export const isAuthRequest = (requestUrl: string) => {
  const url = new URL(requestUrl);
  return authDomains.has(url.host);
};

export const isGraphRequest = (requestUrl: string) => {
  const url = new URL(requestUrl);
  return graphDomains.has(url.host);
};

export const requestToken = async (
  account: AccountInfo | null,
  instance: IPublicClientApplication
): Promise<AuthenticationResult> => {
  return requestAuthResult(account, instance, getTokenRequest(instance));
};

export const requestGraphToken = async (
  account: AccountInfo | null,
  instance: IPublicClientApplication
): Promise<AuthenticationResult> => {
  return requestAuthResult(account, instance, graphTokenRequest);
};

const requestAuthResult = async (
  account: AccountInfo | null,
  instance: IPublicClientApplication,
  request: SilentRequest
): Promise<AuthenticationResult> => {
  if (!account) {
    throw Error("No logged in account found.");
  }

  const accessTokenRequest = {
    ...request,
    account,
  };

  let result = null;
  try {
    result = await instance.acquireTokenSilent(accessTokenRequest);
  } catch (error) {
    console.warn("Silent token acquisition failed. Trying popup.", error);
    const popupReq: PopupRequest = {
      ...accessTokenRequest,
      state: new URL(window.location.href).origin,
    };
    result = await instance.acquireTokenPopup(popupReq);
  }
  return result;
};
